(function(){
'use strict';
var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function preloader(){
  var el = document.getElementById('mm-preload');
  if(!el || el.dataset.ready) return;
  el.dataset.ready = '1';
  var done = false;
  function hide(){ if(done) return; done = true; el.classList.add('mm-gone'); setTimeout(function(){ el.remove(); }, 600); }
  if(reduceMotion){ hide(); return; }
  window.addEventListener('load', function(){ setTimeout(hide, 250); });
  setTimeout(hide, 1400);
}

function cursor(){
  if(reduceMotion) return;
  if(document.getElementById('mm-pf-cur')) return;
  var cur = document.getElementById('mm-g-cur');
  if(!cur || cur.dataset.ready) return;
  cur.dataset.ready = '1';
  var raf = null, x = 0, y = 0, shown = false;
  document.addEventListener('mousemove', function(e){
    x = e.clientX; y = e.clientY;
    if(!shown){ cur.classList.add('mm-g-show'); shown = true; }
    if(!raf){ raf = requestAnimationFrame(function(){ cur.style.left = x + 'px'; cur.style.top = y + 'px'; raf = null; }); }
  });
  document.addEventListener('mouseleave', function(){ cur.classList.remove('mm-g-show'); shown = false; });
  function bindTargets(){
    document.querySelectorAll('a,button,input,textarea,select,[role="button"]').forEach(function(el){
      if(el.dataset.mmCurBound) return;
      el.dataset.mmCurBound = '1';
      el.addEventListener('mouseenter', function(){ cur.classList.add('mm-g-big'); });
      el.addEventListener('mouseleave', function(){ cur.classList.remove('mm-g-big'); });
    });
  }
  bindTargets();
  document.addEventListener('shopify:section:load', function(){ setTimeout(bindTargets, 150); });
  new MutationObserver(function(){ bindTargets(); }).observe(document.body, {childList:true, subtree:true});
}

function revealEngine(){
  var targets = document.querySelectorAll('[data-mm-reveal]:not(.mm-revealed), .mm-reveal:not(.mm-revealed)');
  if(!targets.length) return;
  if(reduceMotion || !('IntersectionObserver' in window)){
    targets.forEach(function(t){ t.classList.add('mm-revealed'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry, i){
      if(entry.isIntersecting){
        var el = entry.target;
        var delay = el.dataset.mmRevealDelay ? parseInt(el.dataset.mmRevealDelay, 10) : (i % 4) * 70;
        setTimeout(function(){ el.classList.add('mm-revealed'); }, delay);
        io.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  targets.forEach(function(t){ io.observe(t); });
}

// Vertical scroll progress — fills top to bottom along the right edge
function scrollProgress(){
  var bar = document.getElementById('mm-scroll-progress');
  if(!bar || bar.dataset.ready) return;
  bar.dataset.ready = '1';
  var raf = null;
  function update(){
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? (doc.scrollTop / max) * 100 : 0;
    bar.style.height = pct + '%';
    raf = null;
  }
  window.addEventListener('scroll', function(){ if(!raf) raf = requestAnimationFrame(update); }, {passive:true});
  window.addEventListener('resize', function(){ if(!raf) raf = requestAnimationFrame(update); });
  update();
}

function run(){ preloader(); cursor(); revealEngine(); scrollProgress(); }
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
document.addEventListener('shopify:section:load', function(){ setTimeout(revealEngine, 150); });
})();
